var map = {
	"./BG2.jpg": 674,
	"./COMEDK.jpg": 176,
	"./Facebook.png": 872,
	"./JEE.jfif": 191,
	"./KCET.png": 649,
	"./Loading_icon.gif": 293,
	"./NEET.jpg": 218,
	"./im1.jpg": 571,
	"./im2.jfif": 862,
	"./instagram.png": 419,
	"./linkedin.png": 267,
	"./logo.jpg": 369,
	"./news1.jpg": 544,
	"./news2.jpg": 753,
	"./news3.jpg": 361,
	"./thumb-up.png": 931,
	"./twitter.png": 951,
	"./web-surfing.svg": 748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;